<template>
  <div class="footer-navigation text-size-14">
    <span
      @click="showWPPage(item.to)"
      v-for="item in navItems"
      :key="item.to"
      class="item mr-3 pointer"
      >{{ $t(item.label) }}</span
    >
  </div>
</template>
<script>
export default {
  name: 'FooterNavigation',
  data() {
    return {
      navItems: [
        {
          to: '/imprint',
          label: 'navigation.imprint',
        },
        {
          to: '/about',
          label: 'navigation.about',
        },
        {
          to: '/terms',
          label: 'navigation.terms',
        },
        {
          to: '/dataprotection',
          label: 'navigation.dataprotection',
        },
      ],
    };
  },
  props: {},
};
</script>
<style lang="scss" scoped>
.footer-navigation {
  position: fixed;
  bottom: 20px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
</style>
